import { ColumnDef } from '@tanstack/react-table';
import { Counter, EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    EmptyStateProps,
    IconName,
    Stack,
    Table,
    TableActiveColumnFilters,
    TableBulkActionButton,
    TableHeader,
    TableProvider,
    useTableState,
} from '@optimus-web/core';
import { useCounters } from '../queries/useCounters';
import { useRouteTitle } from '../../../layouts/useRouteTitle';

interface CountersTableProps {
    counterTypes: EnterpriseScopeCounterDiscriminator[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tableColumns: ColumnDef<Counter, any>[];
    openDialog: () => void;
    emptyState?: EmptyStateProps;
    showAddButton?: boolean;
}

export const CountersTable = ({
    counterTypes,
    tableColumns,
    openDialog,
    emptyState,
    showAddButton = false,
}: CountersTableProps) => {
    const title = useRouteTitle();
    const { data: counters, isFetching } = useCounters(counterTypes);
    const [tableState, setTableState] = useTableState<Counter>({
        pagination: {
            show: false,
        },
    });

    return (
        <TableProvider columns={tableColumns} state={tableState} onStateChange={setTableState}>
            <Stack itemAlignment="center" distribution="space-between">
                <TableHeader title={title} />
                <TableActiveColumnFilters />
                {showAddButton ? (
                    <TableBulkActionButton icon={IconName.Add} onClick={openDialog} variant="tertiary">
                        <LocalizedText textKey={TextKey.Add} />
                    </TableBulkActionButton>
                ) : null}
            </Stack>
            <Table
                loading={isFetching}
                uniqueRowId="id"
                data={counters || []}
                fixedFirstColumn
                emptyState={emptyState}
                amountOfRows={counters?.length ?? 0}
            />
        </TableProvider>
    );
};
